import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ e('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#A2001D" d="M5.858 34.142a20.115 20.115 0 0 0 2.673 2.246L36.388 8.531a20.107 20.107 0 0 0-4.92-4.919L3.612 31.47a20.125 20.125 0 0 0 2.246 2.673Z"></path><path fill="#0052B4" d="M5.858 5.858c-6.31 6.31-7.521 15.785-3.637 23.312L29.17 2.222C21.643-1.663 12.167-.452 5.858 5.858Z"></path><path fill="#496E2D" d="M34.142 34.142c6.31-6.31 7.52-15.785 3.636-23.312L10.83 37.778c7.526 3.885 17.002 2.674 23.312-3.636Z"></path><path fill="#FFDA44" d="m16.521 11.304-2.24 1.054 1.193 2.171-2.434-.466-.308 2.459-1.695-1.808-1.695 1.808-.309-2.458-2.433.465 1.193-2.17-2.24-1.055 2.24-1.054L6.6 8.08l2.433.465.309-2.458 1.695 1.808 1.695-1.808.308 2.458 2.434-.465-1.194 2.17 2.241 1.054Z"></path>', 5), c = [
  o
];
function h(i, n) {
  return t(), a("svg", l, [...c]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
